import { BaseApiRouteService } from "mrb/core";

class LanguageApiRouteService extends BaseApiRouteService {
    constructor() {
        super("lookups/app-languages");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery}`, filter);
    }

    create(resource) {
        return super.create(this.base, resource);
    }
}

export default LanguageApiRouteService;
